if(typeof react-native-sqlite-storage === 'undefined') { var e = new Error("Cannot find module 'react-native-sqlite-storage'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = react-native-sqlite-storage;